import React from 'react';
import './DoctorModal.css';

function DoctorModal({ doctor, show, onClose }) {
    if (!show || !doctor) return null;

    const handleConsult = () => {
        const message = `Hello, I would like to consult with ${doctor.name}`;
        window.open(`https://wa.me/919999999999?text=${encodeURIComponent(message)}`, '_blank');
    };

    const handleBook = () => {
        // Triggering the main appointment modal requires context refactoring. 
        // For now, we'll suggest using the main button or scroll to top.
        // Ideally, move showModal state to AppContext.
        onClose();
        const navBtn = document.querySelector('.create-account .btn');
        if (navBtn) navBtn.click(); // Try to click the navbar button if present
    };

    return (
        <div className="doctor-modal-overlay" onClick={onClose}>
            <div className="doctor-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={onClose}>&times;</button>
                <div className="modal-body">
                    <div className="modal-left">
                        <h2>{doctor.name}</h2>
                        <p><strong>Speciality:</strong> {doctor.speciality}</p>
                        <p><strong>Experience:</strong> {doctor.experience}</p>
                        <p><strong>About:</strong> {doctor.about}</p>
                        <div className="modal-actions">
                            <button className="btn-consult" onClick={handleConsult}>Consult Now</button>
                            <button className="btn-book" onClick={handleBook}>Book Appointment</button>
                        </div>
                    </div>
                    <div className="modal-right">
                        <img src={doctor.image} alt={doctor.name} className="modal-image" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DoctorModal;
